import { get, post, put } from './request'
import type { UserInfo } from '@/types'

// 转换下划线命名为驼峰命名
function convertToCamelCase(obj: any): any {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => convertToCamelCase(item))
  }
  
  const result: any = {}
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // 将下划线命名转换为驼峰命名
      const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
      result[camelKey] = convertToCamelCase(obj[key])
    }
  }
  return result
}

export const userApi = {
  // 用户注册
  register(data: {
    username: string
    password: string
    phone: string
    inviteCode?: string
  }) {
    return post<{ userId: number; token: string; expiresIn: number }>('/auth/register', data)
  },

  // 用户登录
  async login(data: { username: string; password: string }) {
    const res = await post<{ userId: number; token: string; expiresIn: number; userInfo: any }>('/auth/login', data)
    // 转换用户信息格式
    if (res.userInfo) {
      res.userInfo = convertToCamelCase(res.userInfo)
    }
    return res as { userId: number; token: string; expiresIn: number; userInfo: UserInfo }
  },

  // 获取用户信息
  async getProfile() {
    const res = await get<any>('/user/profile')
    // 转换数据格式
    return convertToCamelCase(res) as UserInfo
  },

  // 更新用户信息
  updateProfile(data: { nickname?: string; avatar?: string }) {
    return put('/user/profile', data)
  },

  // 修改密码
  changePassword(data: { oldPassword: string; newPassword: string }) {
    return put('/user/password', data)
  },

  // 获取用户统计数据
  getStats() {
    return get('/user/stats')
  },

  // 微信登录
  async wechatLogin(data: { code: string; state?: string }) {
    const res = await post<{ userId: number; token: string; expiresIn: number; userInfo: any; openid?: string }>('/auth/wechat/login', data)
    // 转换用户信息格式
    if (res.userInfo) {
      res.userInfo = convertToCamelCase(res.userInfo)
    }
    return res as { userId: number; token: string; expiresIn: number; userInfo: UserInfo; openid?: string }
  }
}
